/**
 * Product options for the product-type rules: the FI's own catalog
 * (`fi.config.product_types`, keyed by the product code its core reports on
 * each account). Empty without a catalog — the service has no product codes
 * to match then, so the panels show that instead of rows.
 * @param {Object<string, {name?: string, category?: string}>|null} fiProductTypes
 * @returns {Array<{value: string, label: string}>}
 */
export function getProductTypeOptions(fiProductTypes) {
    return Object.entries(fiProductTypes ?? {}).map(([code, product]) => ({
        value: code,
        label: product?.name ? `${product.name} (${code})` : code,
    }));
}
